// extracted by mini-css-extract-plugin
module.exports = {"articles__grid":"featured-articles_articles__grid__UaUxb"};